import React from "react";
export function QuoteInclusions(props) {
  const { quote } = props;
  const inclusionsList = [];

  for (const [key, value] of Object.entries(quote)) {
    if (
      key !== "discount" &&
      key !== "total" &&
      value !== 0 &&
      key !== "gst_charges"
    ) {
      let tempKey = key.replaceAll("_", " ");
      tempKey = tempKey.replaceAll("charge", "");
      inclusionsList.push(tempKey);
    }
  }
  const JSX = (
    <div className="row">
      <div className="col-sm-12 col-md-8">
        <div class="inclusions-container">
          {inclusionsList.map((inclusion) => {
            return (
              <div class="inclusion-list">
                <div class="rectangle-icon"> </div>
                <div class="charge-text"> {inclusion} </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
  return JSX;
}
